import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import { t } from 'services/Translation'

import { ElementGroup } from '../../elements.types'
import { genElementConfig } from '../../genElementConfig'
import TestHotspotDemo from './TestHotspotDemo'
import TestHotspotEditorActions from './TestHotspotEditorActions'
import TestHotspotElement from './TestHotspotElement'
import TestHotspotFormBrand from './TestHotspotFormBrand'
import { STYLE_FORM_SCHEMA } from './TestHotspotFormStyle'
import TestHotspotFormValue from './TestHotspotFormValue'
import testHotspot from './assets/hotspot.svg'

export default genElementConfig(CONFIG_ELEMENTS.testHotspot, {
  label: t('elements.testHotspot.label'),
  icon: testHotspot,
  group: ElementGroup.test,
  styleFields: STYLE_FORM_SCHEMA,
  Element: TestHotspotElement,
  Demo: [TestHotspotDemo],
  FormValue: TestHotspotFormValue,
  FormBrand: TestHotspotFormBrand,
  EditorActions: TestHotspotEditorActions,
})
